<template>
  <div v-if="loading_page === true">
    <v-sheet
      :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class="pa-3"
    >
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div class="mt-1" v-else>
    <v-slide-x-reverse-transition>
      <v-alert
        type="error"
        class="alert_all_page"
        v-if="alert_error === true"
        >{{ alert_message_error }}</v-alert
      >
    </v-slide-x-reverse-transition>
    <v-row>
      <v-col xs="12" sm="12" md="6" lg="8" xl="8" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">เเก้ไขรอบโอนสินค้า</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <div class="mt-1">
      <v-card class="mb-5" elevation="4" style="border-radius: 15px">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="form" @submit.prevent="addProductTransferStore()">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/ordericon.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">
                        ข้อมูลสาขาที่ต้องการเเก้ไขโอนสินค้า
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  xs="6"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  cols="6"
                  class="ml-5 pl-5"
                >
                  <v-form-group>
                    <label class="label_form_text"
                      >สาขา <span class="required--text">*</span></label
                    >

                    <v-autocomplete
                      class="input-radius"
                      color="#D6BFAF"
                      :items="branch_option"
                      item-text="owner_name"
                      item-value="customer_code"
                      v-model="branch_select"
                      placeholder="กรุณาเลือกสาขาที่ต้องการโอนสินค้า"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      outlined
                      dense
                      disabled
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/cycle.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">รายการสินค้า</div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  cols="12"
                  class="ml-5 px-5"
                >
                  <v-form-group>
                    <label class="label_form_text"
                      >สินค้า <span class="required--text">*</span></label
                    >
                    <v-autocomplete
                      class="input-radius"
                      color="#D6BFAF"
                      v-model="productSelect"
                      :items="productList"
                      item-text="name"
                      item-value="product_code"
                      @change="addProductToTable"
                      placeholder="กรุณาเลือกสินค้า"
                      hide-details="auto"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  cols="12"
                  class="ml-5 px-5"
                  v-if="showDataTable.length > 0"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="150" class="text-left">ลำดับ</th>
                          <th width="150" class="text-left">รหัสสินค้า</th>
                          <th class="text-left">ชื่อสินค้า</th>
                          <th class="text-left">ชื่อทางแพทย์</th>
                          <th width="180" class="text-left">จำนวนในคลัง</th>
                          <th width="180" class="text-left">
                            จำนวนโอน <span class="required--text">*</span>
                          </th>
                          <th width="100" class="text-left">ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in showDataTable" :key="index">
                          <template v-if="item != null">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.product_code }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.name_sci }}</td>
                            <td>{{ item.in_stock }}</td>
                            <td>
                              <v-text-field
                                elevation="4"
                                class="input-radius my-2"
                                v-model="item.qty"
                                :rules="[
                                  (v) =>
                                    validateQty() ||
                                    'กรุณาอย่าใส่จำนวนเกิน',
                                  (v) => !!v || 'กรุณากรอกข้อมูล',
                                ]"
                                hide-details="auto"
                                outlined
                                dense
                                single-line
                                required
                              ></v-text-field>
                            </td>
                            <td>
                              <v-btn
                                elevation="4"
                                class="ma-2"
                                outlined
                                color="error"
                                title="ลบข้อมูล"
                                height="45"
                                small
                                style="border-radius: 10px"
                                @click="deleteProductTable(index)"
                              >
                                <v-icon>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content: end">
                    <v-btn
                      class="btn_data btn_cancel mx-4"
                      @click="
                          link(
                            '/arin/pos/transfergoods'
                          )
                        "
                      large
                      >ยกเลิก</v-btn
                    >
                    <v-btn
                      type="submit"
                      class="btn_data btn_add"
                      elevation="4"
                      large
                      >บันทึกแบบฟอร์มคืนสินค้า</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "transfer_goodsadd",
  data() {
    return {
      loading_page: false,
      alert_error: false,
      alert_message_error: null,
      branch_select: "",
      branch_option: "",
      productTalble: "",
      productList: [],
      productSelect: "",
      productTable: [], // เก็บข้อมูลสินค้าที่เลือก
      qty: 0,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "โอนสินค้า",
          disabled: false,
          // href: "/arin/pos/transfergoods",
        },
        {
          text: "เเก้ไขรอบโอนสินค้า",
          disabled: false,
          href: "#",
        },
      ],
      order: ["ไทย", "จีน"],
      create_id: 1,
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "ลำดับ",
          value: "",
          fixed: true,
          sortable: false,
          width: "150px",
        },
        {
          text: "รหัสสินค้า",
          value: "product_code",
          fixed: true,
          sortable: false,
          width: "150px",
        },
        {
          text: "ชื่อสินค้า",
          value: "name",
          fixed: true,
          sortable: false,
          width: "auto",
        },
        {
          text: "ชื่อทางแพทย์",
          value: "name_sci",
          fixed: true,
          sortable: false,
          width: "auto",
        },
        {
          text: "จำนวนในคลัง",
          value: "in_stock",
          sortable: false,
          fixed: true,
          width: "180px",
        },
        {
          text: "จำนวนโอน",
          value: "qty",
          fixed: true,
          sortable: false,
          width: "180px",
          required: true,
        },
        {
          text: "ลบ",
          value: "",
          fixed: true,
          sortable: false,
          width: "180px",
        },
      ],
      search: "",
      showDataTable: [],
    };
  },
  methods: {
    async getBranchAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/warehouse/branchall", config).then((res) => {
        if (res.data.successful === true) {
          this.branch_option = res.data.branchtList;
          this.loading_page = false;
        }
      });
    },

    link(link) {
      window.location.href = link;
    },

    async showProductAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/warehouse/productall", config).then((res) => {
        if (res.data.successful === true) {
          this.productList = res.data.productList; // รายการสินค้าที่จะโอน
          this.loading_page = false;
        }
      });
    },

    addProductToTable() {
      if (this.showDataTable.length > 0) {
        let isProductAlreadyAdded;
        isProductAlreadyAdded = this.showDataTable.some(
          (product) => product.product_code === this.productSelect
        );
        if (isProductAlreadyAdded) {
          this.alert_error = true;
          this.alert_message_error = "สินค้านี้ถูกเพิ่มไปแล้ว";
          setTimeout(() => {
            this.alert_error = false;
          }, 3000);
          return; // ถ้ามีสินค้าอยู่แล้วให้ return ไม่ต้องเพิ่มซ้ำ
        }
      }

      const selectedProduct = this.productList.find(
        (product) => product.product_code === this.productSelect
      );

      if (selectedProduct) {
        let index = this.productTable.findIndex((el) => {
          if (el.product_code == selectedProduct.product_code) {
            if (el.is_delete) {
              return el;
            }
          }
        });

        if (index > -1) {
          this.productTable[index] = {
            ...this.productTable[index],
            qty: 0,
            is_delete: false,
          };
        } else {
          this.productTable.push({
            ...selectedProduct,
            qty: this.qty,
            create_id: this.create_id,
          });
        }

        this.productSelect = "";
        this.qty = 0;
        this.create_id++;

        this.showDataTable = [];
        this.showDataTable = this.productTable.filter((el) => !el.is_delete);
      }
    },

    deleteProductTable(index) {
      if (!this.showDataTable[index].create_id) {
        let indexProduct = this.productTable.findIndex(
          (el) => el.product_code == this.showDataTable[index].product_code
        );
        this.productTable[indexProduct] = {
          ...this.productTable[indexProduct],
          is_delete: true,
        };
      } else {
        this.productTable.splice(index, 1);
      }
      this.showDataTable.splice(index, 1);
    },

    validateQty() {
      // if(inStock < 0){
      //   return true
      // }
      // else if (value > inStock) {
      //   return `จำนวนสินค้าไม่ควรเกิน ${inStock}`;
      // }
      return true;
    },
    addProductTransferStore() {
      if (this.$refs.form.validate()) {
        let fillTable = this.showDataTable.filter((table) => !table.is_delete);

        this.productTable = this.productTable.map((product) => {
          let qty =
            fillTable.find(
              (table) => product.product_code === table.product_code
            )?.qty || 0;
          if (qty == 0) {
            return product;
          } else {
            return {
              ...product,
              qty: qty,
            };
          }
        });

        const data = {
          history_id: this.$route.params.id,
          product_list: this.productTable,
        };

        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        HTTP_ARIN.post("/warehouse/edittransferproduct", data, config).then(
          (res) => {
            if (res.data.successful === true) {
              let timerInterval;
              Swal.fire({
                title: "เสร็จสิ้น",
                text: "เพิ่มข้อมูลเรียบร้อย",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  timerInterval = setInterval(() => {});
                },
                willClose: () => {
                  clearInterval(timerInterval);
                  setTimeout(function () {
                    window.location.href = "/arin/pos/transfergoods";
                  });
                },
              });
            }
          }
        );
      }
    },
    async getTransfer() {
      this.loading_page = true;
      //   console.log(this.$route.params.id)
      this.product = [];
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(
        "/warehouse/transferfirst/" + this.$route.params.id,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.branch_select = res.data.TransferFirst.history_store_code;
          this.productTable = res.data.TransferProductList;
          this.showDataTable = JSON.parse(JSON.stringify(this.productTable));
          this.loading_page = false;
        }
      });
    },
  },
  created() {},
  async mounted() {
    await this.getBranchAll();
    await this.showProductAll();
    this.getTransfer();
  },
};
</script>

<style scoped>
.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.btn_add {

  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
    color: #fff;
  
}

.btn_cancel {

background: #dddddd,
  #88b358 !important;

}

.btn_data{
  font-size: 16px;
  border-radius: 10px;
  width: fit-content;
}
</style>
